<template>
  <ModalDialog
    ref="dialog"
    title="Edit Order"
    :submitting="submitting"
    submitTitle="Update"
    icon="fa-shopping-cart"
    :scrollable="true"
    @closed="onClosed"
    @submitted="onSubmitted">

    <div v-if="holdProcessLoading">
      <p class="text-center">Placing a hold on the order while editing</p>
      <Spinner />
    </div>

    <FormGroup v-bind:form="dialogForm" :labelColumnSize="3" v-show="!holdProcessLoading">
      <ContentTitle>Order Details</ContentTitle>
      <FormRow label="Customer Reference No.">
        <FormInputText v-model="order.customerRef" field="customerRef" placeholder="Customer Reference" />
      </FormRow>
      <FormRow label="Notes">
        <FormInputTextArea v-model="order.notes" field="notes" placeholder="Customer / Delivery Notes" large />
      </FormRow>
      <div v-if="isCustomContactPerson">
        <FormHorizontalRule />
        <ContentTitle>Custom Contact Details</ContentTitle>
        <FormRow label="Contact Name">
          <FormInputText v-model="order.customContactName" field="customContactName" placeholder="Contact Name" />
        </FormRow>
        <FormRow label="Contact Email">
          <FormInputEmail v-model="order.customContactEmail" field="customContactEmail" placeholder="Contact Email" />
        </FormRow>
        <FormRow label="Contact Mobile">
          <FormInputText v-model="order.customContactMobile" field="customContactMobile" placeholder="Contact Mobile" />
        </FormRow>
        <FormRow label="Contact Details">
          <FormInputTextArea v-model="order.customContactDetails" field="customContactDetails" placeholder="Contact Details" />
        </FormRow>

      </div>
      <FormHorizontalRule />
      <ContentTitle>Order Schedule Details</ContentTitle>
      <FormRow label="Request Date" v-show="canEditRequiredDate">
        <FormCheckbox v-model="customerRequestedDate" :note="`Currently estimated for ${currentOrderDateEstimateDisplay}`"/>
      </FormRow>
      <FormRow label="Date Requested" v-show="customerRequestedDate && canEditRequiredDate">
        <FormDateTime v-model="order.dateRequested" field="dateRequested" />
      </FormRow>
      <FormRow label="Urgent Order" v-show="customerRequestedDate && canEditRequiredDate">
        <FormCheckbox v-model="order.isUrgent" />
      </FormRow>
      <FormRow label="Urgent Order Reason" v-show="customerRequestedDate && canEditRequiredDate && order.isUrgent">
        <FormInputTextArea v-model="order.urgentReason" field="urgentReason" placeholder="Urgent Order Reason" />
      </FormRow>
    </FormGroup>
  </ModalDialog>
</template>

<script>
import _ from 'lodash'
import moment from 'moment'

import form from '@/mixins/form'
import ModalDialog from '@/components/modalDialog.vue'
import ModalDialogMixin from '@/mixins/modalDialog'

import { OrderHoldTypes } from '@/store/types'

export default {
  name: "EditOrderDialog",
  mixins: [
    ModalDialogMixin,
    form
  ],
  components: {
    ModalDialog,
  },
  props: {
    orderId: Number
  },
  data() {
    return {
      holdProcessLoading: true,
      responseInfo: {},
      dialogForm: {},
      submitting: false,
      customerRequestedDate: false,
      order: {},
      accountData: {},
    }
  },
  watch: {
    customerRequestedDate: function() {
      if(this.customerRequestedDate && !this.order.dateRequested) {
        // Default to now
        this.order.dateRequested = moment().local().toDate()
      }
    }
  },
  created() {
  },
  mounted() {
    
  },
  computed: {
    currentOrderDateEstimateDisplay() {
      return this.$options.filters.formatDate(this.order.dateEstimated)
    },
    canEditRequiredDate() {
      // Can only update the required date if the user has order production approval permission
      return this.userHasUpdatePermission(this.PermissionTypes.OrderPermissionTypes.orderProductionApproval)
    },
    isCustomContactPerson() {
      return !this.order.contactPersonId
    }
  },
  methods: {
    show(order) {
      // Reset form
      this.responseInfo = { }
      this.dialogForm = { }

      this.$data.order = _.cloneDeep(order)

      if(this.$data.order.dateRequested)
        this.$data.customerRequestedDate = true

      // Force a hold on the order while editing
      // This prevents further processes from continuing (eg, production) while potential edits are in place
      this.$nextTick(() => {
        this.holdProcessLoading = true
        this.$apiService.ordersService.holdOrder(this.$route.params.id, { holdType: OrderHoldTypes.orderEditing, reason: 'Editing Order' })
        .then(() => {
        })
        .finally(() => {
          this.holdProcessLoading = false
        })
      })

      return ModalDialogMixin.methods.show.call(this, arguments)
    },
    onClosed() {
      this.modalClosed(false)
    },
    onSubmitted() {
      this.submitting = true

      var updateData = {
        notes: this.order.notes,
        customerRef: this.order.customerRef
      }

      if(this.canEditRequiredDate) {
        updateData.dateRequested = this.customerRequestedDate ? this.order.dateRequested : null

        updateData.isUrgent = this.order.isUrgent
        updateData.urgentReason = this.order.urgentReason

        if(!this.customerRequestedDate)
          updateData.isUrgent = false
      }
      if(this.isCustomContactPerson) {
        updateData.customContactName = this.order.customContactName
        updateData.customContactEmail = this.order.customContactEmail
        updateData.customContactMobile = this.order.customContactMobile
        updateData.customContactDetails = this.order.customContactDetails
      }

      this.$apiService.ordersService.updateOrder(this.orderId, updateData)
      .then(response => {
        this.modalClosed(true)
        this.hide()
      })
      .catch(err => {
        this.$data.dialogForm = this.processFormResponse(err)
      })
      .finally(() => {
        this.$data.submitting = false
      })
    }
  }
}
</script>